<div id="academy-courses" class="page-layout simple">
  <div class="header primary p-24" fxLayout="row" fxLayoutAlign="start center">
    <button mat-icon-button class="mr-16" [routerLink]="'/'+url">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1 class="m-0">{{'LANDINFOCUS.WIZARD.TITUVERI' | translate}}</h1>
  </div>

  <mat-tab-group>
    <mat-tab label="{{'LANDINFOCUS.WIZARD.TITUTABTEM' | translate}}">
      <div fxLayout="column"  >
        <div class="m" fxLayout="row" >

          <mat-expansion-panel  class="mb-20 m1"  *ngIf="preguntasReactivosPLantilla1.length >0">
            <mat-expansion-panel-header class="accent-100">
              <mat-panel-title class="">
                Templates:  {{plantillaselect}}
              </mat-panel-title>
              <mat-panel-description>
              {{preguntasReactivosPLantilla1.length}} {{'LANDINFOCUS.ADMIN-PREG.PREGUN' | translate}}
              </mat-panel-description>
            </mat-expansion-panel-header>
             <ng-container *ngFor="let plantilla1 of  preguntasReactivosPLantilla1">
            <mat-list>
              <mat-list-item >
                <mat-icon matListIcon>arrow_right</mat-icon>
                <mat-list-item>{{plantilla1.pregunta}}</mat-list-item>
                <mat-divider ></mat-divider>
              </mat-list-item>
            </mat-list>
          </ng-container>

          </mat-expansion-panel>
        </div>

        <div fxLayout="row"  fxFlex="100">
          <mat-expansion-panel  class="mb-20  m1"  *ngIf="preguntasReactivosPLantilla2.length >0">
            <mat-expansion-panel-header class="accent-100">
              <mat-panel-title>
                Templates:  {{plantillaselect2}}
              </mat-panel-title>
              <mat-panel-description>
              {{preguntasReactivosPLantilla2.length}} {{'LANDINFOCUS.ADMIN-PREG.PREGUN' | translate}}
              </mat-panel-description>
            </mat-expansion-panel-header>
            <ng-container *ngFor="let plantilla2 of  preguntasReactivosPLantilla2">
            <mat-list>
              <mat-list-item >
                <mat-icon matListIcon>arrow_right</mat-icon>
                <mat-list-item>{{plantilla2.pregunta}}</mat-list-item>
                <mat-divider ></mat-divider>
              </mat-list-item>
            </mat-list>
          </ng-container>
          </mat-expansion-panel>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="{{'LANDINFOCUS.WIZARD.TITUTABADI' | translate}}" *ngIf="preguntasAdicionalesFocus">
 <ng-container *ngIf="preguntasAdicionalesFocus.idiomaAdicional.length==0">
   <div class="statusDiv" fxLayout="column" fxLayoutAlign="center center"  [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
     <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
       <h2>{{'LANDINFOCUS.ADMIN-PREG.NO-ADICI' | translate}}</h2>
       <mat-icon class="ml-20 s-40">error_outline</mat-icon>
     </div>
   </div>
      </ng-container>
      <ng-container *ngIf="preguntasAdicionalesFocus.preguntas.length>0">
      <div fxLayout="column"  >
        <ng-container *ngIf="preguntasEncuestaAbiertas.length>0">
        <div class="m" fxLayout="row" >
          <mat-expansion-panel class="mb-20 m1"  >
            <mat-expansion-panel-header class="accent-100">
              <mat-panel-title>
                {{'LANDINFOCUS.ADMIN-PREG.TITULO-ABIE' | translate}}
              </mat-panel-title>
              <mat-panel-description>
                {{preguntasEncuestaAbiertas.length}} {{'LANDINFOCUS.ADMIN-PREG.PREGUN' | translate}}
              </mat-panel-description>
            </mat-expansion-panel-header>
            <mat-accordion>
              <ng-container *ngFor=" let abiertas of preguntasEncuestaAbiertas" >
                <mat-expansion-panel class="m-20 m" >
                  <mat-expansion-panel-header class="accent-100">
                    <mat-panel-title>
                      {{'LANDINFOCUS.ADMIN-PREG.PREGUNSUB' | translate}}
                    </mat-panel-title>
                    <mat-panel-description>
                      {{'LANDINFOCUS.ADMIN-PREG.DESCRIP-PREGUN' | translate}}
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <p>{{'LANDINFOCUS.ADMIN-PREG.PREGUNSUB' | translate}}</p>
                  <mat-horizontal-stepper>
                    <mat-step label="{{'LANDINFOCUS.IDIOM-NATIVO.'+idiomaNativo | translate}}" state="language">
                      <div fxLayout="row" fxLayoutAlign="space-between start" class="mt-20">
                        <mat-form-field class="input" appearance="outline" fxFlex="100">
                          <mat-label>{{'LANDINFOCUS.ADMIN-PREG.PREGUNSUB' | translate}}</mat-label>
                          <textarea matInput required   [(ngModel)]="abiertas.pregunta" (blur)="actualizarTextoPregunta(abiertas.pregunta,abiertas._id)"></textarea>
                        </mat-form-field>
                      </div>
                    </mat-step>
                    <ng-container *ngIf="preguntasTraduccionesAdicionalesFocus">
                      <div class="" *ngFor="let traduccionesAdi of preguntasTraduccionesAdicionalesFocus.arrayMostrar">
                        <mat-step label="{{'LANDINFOCUS.IDIOM-NATIVO.'+traduccionesAdi.clave | translate}}" state="language">
                          <div fxLayout="row" fxLayoutAlign="space-between start" class="mt-10" *ngFor="let traduccionesPreguntasAdi of traduccionesAdi.preguntas">
                            <ng-container *ngIf="traduccionesPreguntasAdi._id == abiertas._id">
                              <mat-form-field class="input" appearance="outline" fxFlex="100">
                                <mat-label>{{'LANDINFOCUS.ADMIN-PREG.PREGUNSUB' | translate}}</mat-label>
                                <textarea matInput required   [(ngModel)]="traduccionesPreguntasAdi.traduccion" (blur)="actualizaAdicionalTraduccionPregunta(traduccionesAdi.idiomaId,traduccionesPreguntasAdi._id,traduccionesPreguntasAdi.traduccion)"></textarea>
                              </mat-form-field>
                            </ng-container>
                          </div>
                        </mat-step>
                      </div>
                      <!-- Icon overrides. -->
                      <ng-template matStepperIcon="language">
                        <mat-icon>language</mat-icon>
                      </ng-template>
                    </ng-container>


                  </mat-horizontal-stepper>


                </mat-expansion-panel>
              </ng-container>
            </mat-accordion>
          </mat-expansion-panel>


        </div>
        </ng-container>
        <!-- container de preguntas de una Opcion -->
        <ng-container *ngIf="preguntasEncuestaUnaOpcion.length>0">
        <div class="" fxLayout="row" >
          <mat-expansion-panel class="mb-20  m1">
            <mat-expansion-panel-header class="accent-100">
              <mat-panel-title>
                {{'LANDINFOCUS.ADMIN-PREG.TITULO-UNAOPC' | translate}}
              </mat-panel-title>
              <mat-panel-description>
                {{preguntasEncuestaUnaOpcion.length}} {{'LANDINFOCUS.ADMIN-PREG.PREGUNSUB' | translate}}
              </mat-panel-description>
            </mat-expansion-panel-header>
            <mat-accordion>
              <ng-container *ngFor=" let unaopcion of preguntasEncuestaUnaOpcion;" >
                <mat-expansion-panel class="mb-20 m">
                  <mat-expansion-panel-header class="accent-100">
                    <mat-panel-title>
                      {{'LANDINFOCUS.ADMIN-PREG.PREGUNSUB' | translate}}
                    </mat-panel-title>
                    <mat-panel-description>
                      {{'LANDINFOCUS.ADMIN-PREG.DESCRIP-PREGUN' | translate}}
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <p>{{'LANDINFOCUS.ADMIN-PREG.PREGUNSUB' | translate}}</p>
                  <mat-horizontal-stepper>
                    <mat-step label="{{'LANDINFOCUS.IDIOM-NATIVO.'+idiomaNativo | translate}}" state="language">
                      <div fxLayout="row" fxLayoutAlign="space-between start" class="mt-20">
                        <mat-form-field class="input" appearance="outline" fxFlex="100">
                          <mat-label>{{'LANDINFOCUS.ADMIN-PREG.PREGUNSUB' | translate}}</mat-label>
                          <textarea matInput required   [(ngModel)]="unaopcion.pregunta" (blur)="actualizarTextoPregunta(unaopcion.pregunta,unaopcion._id)"></textarea>
                          <mat-error>Error, complete la pregunta</mat-error>
                        </mat-form-field>
                      </div>
                      <p>{{'LANDINFOCUS.ADMIN-PREG.OPC' | translate}}</p>
                      <ng-container  *ngFor=" let opcionesunaopcion of unaopcion.opciones">
                        <div fxLayout="row" fxLayoutAlign="space-between start" class="mt-20" fxFlex="100">
                          <mat-form-field class="input" appearance="outline" fxFlex="100">
                            <mat-label>{{'LANDINFOCUS.ADMIN-PREG.OPCSUB' | translate}}</mat-label>
                            <textarea matInput required   [(ngModel)]="opcionesunaopcion.respuesta" (blur)="actualizarTextoOpcionPregunta(opcionesunaopcion.respuesta,unaopcion._id,opcionesunaopcion._id)" ></textarea>
                            <mat-error>Error, complete la pregunta</mat-error>
                          </mat-form-field>
                        </div>
                      </ng-container>
                    </mat-step>
                    <ng-container *ngIf="preguntasTraduccionesAdicionalesFocus">
                      <div class="" *ngFor="let traduccionesAdi of preguntasTraduccionesAdicionalesFocus.arrayMostrar">
                        <mat-step label="{{'LANDINFOCUS.IDIOM-NATIVO.'+traduccionesAdi.clave | translate}}" state="language">

                          <div fxLayout="column" fxLayoutAlign="space-between start" class="mt-10" *ngFor="let traduccionesPreguntasAdi of traduccionesAdi.preguntas">
                            <ng-container *ngIf="traduccionesPreguntasAdi._id == unaopcion._id">
                              <div class="" fxLayout="row" style="width:100%">
                                <mat-form-field class="input" appearance="outline" fxFlex="100">
                                  <mat-label>{{'LANDINFOCUS.ADMIN-PREG.PREGUNSUB' | translate}}</mat-label>
                                  <textarea matInput required   [(ngModel)]="traduccionesPreguntasAdi.traduccion" (blur)="actualizaAdicionalTraduccionPregunta(traduccionesAdi.idiomaId,traduccionesPreguntasAdi._id,traduccionesPreguntasAdi.traduccion)"></textarea>
                                </mat-form-field>

                              </div>
                              <div class="" fxLayout="row">
                                <p>{{'LANDINFOCUS.ADMIN-PREG.OPC' | translate}}</p>
                              </div>

                              <ng-container  *ngFor=" let opcionesunaopcionTraduccion of traduccionesPreguntasAdi.opciones;index as idxOpc;">
                                  <div fxLayout="row" fxLayoutAlign="space-between start" class="mt-20" style="width:100%">
                                <mat-form-field class="input" appearance="outline" fxFlex="100">
                                  <mat-label>{{'LANDINFOCUS.ADMIN-PREG.OPCSUB' | translate}}</mat-label>
                                  <textarea matInput required   [(ngModel)]="opcionesunaopcionTraduccion.traduccion" (blur)="actualizaTraduccionOpcionBD(traduccionesAdi.idiomaId,traduccionesPreguntasAdi._id,idxOpc,opcionesunaopcionTraduccion.traduccion)"></textarea>
                                  <mat-error>Error, complete la pregunta</mat-error>
                                </mat-form-field>

                              </div>
                              </ng-container>

                            </ng-container>

                          </div>
                        </mat-step>
                      </div>
                      <!-- Icon overrides. -->
                      <ng-template matStepperIcon="language">
                        <mat-icon>language</mat-icon>
                      </ng-template>
                    </ng-container>


                  </mat-horizontal-stepper>
                </mat-expansion-panel>
              </ng-container>
            </mat-accordion>
          </mat-expansion-panel>
        </div>
        </ng-container>
          <!-- container de preguntas de Multiple Opcion -->
        <ng-container *ngIf="preguntasEncuestaMultipleOpcion.length>0">
        <div class="" fxLayout="row" >
          <mat-expansion-panel class="mb-20  m1">
            <mat-expansion-panel-header class="accent-100">
              <mat-panel-title>
                {{'LANDINFOCUS.ADMIN-PREG.TITULO-MULOPC' | translate}}
              </mat-panel-title>
              <mat-panel-description>
                {{preguntasEncuestaMultipleOpcion.length}} {{'LANDINFOCUS.ADMIN-PREG.PREGUN' | translate}}
              </mat-panel-description>
            </mat-expansion-panel-header>
            <mat-accordion>
              <ng-container *ngFor=" let multipleopcion of preguntasEncuestaMultipleOpcion" >
                <mat-expansion-panel class="mb-20">
                  <mat-expansion-panel-header class="accent-100">
                    <mat-panel-title>
                      {{'LANDINFOCUS.ADMIN-PREG.PREGUNSUB' | translate}}
                    </mat-panel-title>
                    <mat-panel-description>
                      {{'LANDINFOCUS.ADMIN-PREG.DESCRIP-PREGUN' | translate}}
                    </mat-panel-description>
                  </mat-expansion-panel-header>

                  <p>{{'LANDINFOCUS.ADMIN-PREG.PREGUNSUB' | translate}}</p>
                  <mat-horizontal-stepper>
                    <mat-step label="{{'LANDINFOCUS.IDIOM-NATIVO.'+idiomaNativo | translate}}" state="language">
                      <div fxLayout="row" fxLayoutAlign="space-between start" class="mt-20">
                        <mat-form-field class="input" appearance="outline" fxFlex="100">
                          <mat-label>{{'LANDINFOCUS.ADMIN-PREG.PREGUNSUB' | translate}}</mat-label>
                          <textarea matInput required   [(ngModel)]="multipleopcion.pregunta" (blur)="actualizarTextoPregunta(multipleopcion.pregunta,multipleopcion._id)"></textarea>
                          <mat-error>Error, complete la pregunta</mat-error>
                        </mat-form-field>
                      </div>
                      <p>{{'LANDINFOCUS.ADMIN-PREG.OPC' | translate}}</p>
                      <ng-container *ngFor=" let opcionesmultipleopcion of multipleopcion.opciones">
                        <div fxLayout="row" fxLayoutAlign="space-between start" class="mt-20">
                          <mat-form-field class="input" appearance="outline" fxFlex="100">
                            <mat-label>{{'LANDINFOCUS.ADMIN-PREG.OPCSUB' | translate}}</mat-label>
                            <textarea matInput required   [(ngModel)]="opcionesmultipleopcion.respuesta" (blur)="actualizarTextoOpcionPregunta(opcionesmultipleopcion.respuesta,multipleopcion._id,opcionesmultipleopcion._id)"></textarea>
                            <mat-error>Error, complete la pregunta</mat-error>
                          </mat-form-field>
                        </div>
                      </ng-container>
                    </mat-step>
                    <ng-container *ngIf="preguntasTraduccionesAdicionalesFocus">
                      <div class="" *ngFor="let traduccionesAdi of preguntasTraduccionesAdicionalesFocus.arrayMostrar">
                        <mat-step label="{{'LANDINFOCUS.IDIOM-NATIVO.'+traduccionesAdi.clave | translate}}" state="language">
                          <div fxLayout="column" fxLayoutAlign="space-between start" class="mt-10" *ngFor="let traduccionesPreguntasAdi of traduccionesAdi.preguntas">
                            <ng-container *ngIf="traduccionesPreguntasAdi._id == multipleopcion._id">
                              <div fxLayout="row" fxLayoutAlign="space-between start" class="mt-20" style="width:100%">
                                <mat-form-field class="input" appearance="outline" fxFlex="100">
                                  <mat-label>{{'LANDINFOCUS.ADMIN-PREG.PREGUNSUB' | translate}}</mat-label>
                                  <textarea matInput required   [(ngModel)]="traduccionesPreguntasAdi.traduccion" (blur)="actualizaAdicionalTraduccionPregunta(traduccionesAdi.idiomaId,traduccionesPreguntasAdi._id,traduccionesPreguntasAdi.traduccion)"></textarea>
                                  <mat-error>Error, complete la pregunta</mat-error>
                                </mat-form-field>
                              </div>
                              <div class="" fxLayout="row">
                                <p>{{'LANDINFOCUS.ADMIN-PREG.OPC' | translate}}</p>
                              </div>
                              <ng-container *ngFor=" let opcionesmultipleopcion of traduccionesPreguntasAdi.opciones; index as idxOpc;">
                                <div fxLayout="row" fxLayoutAlign="space-between start" class="mt-20" style="width:100%">
                                  <mat-form-field class="input" appearance="outline" fxFlex="100">
                                    <mat-label>{{'LANDINFOCUS.ADMIN-PREG.OPCSUB' | translate}}</mat-label>
                                    <textarea matInput required  [(ngModel)]="opcionesmultipleopcion.traduccion" (blur)="actualizaTraduccionOpcionBD(traduccionesAdi.idiomaId,traduccionesPreguntasAdi._id,idxOpc,opcionesmultipleopcion.traduccion)"></textarea>
                                    <mat-error>Error, complete la pregunta</mat-error>
                                  </mat-form-field>
                                </div>
                              </ng-container>

                            </ng-container>
                          </div>
                        </mat-step>
                      </div>
                      <!-- Icon overrides. -->
                      <ng-template matStepperIcon="language">
                        <mat-icon>language</mat-icon>
                      </ng-template>
                    </ng-container>
                  </mat-horizontal-stepper>

                </mat-expansion-panel>
              </ng-container>
            </mat-accordion>
          </mat-expansion-panel>

        </div>
        </ng-container>
      </div>
    </ng-container>

    </mat-tab>
  </mat-tab-group>

  <div fxLayout="row" fxLayoutAlign="end end" class="mb-20 finishBt" *ngIf="banderaEncuestaFocus">
    <ng-container >
      <button *ngIf="banderaEncuestaFocus.estatusVerificacion==2" mat-fab aria-label="boton completar paso" (click)="actualizaBanderaEvaluarEncuesta(5)"
      matTooltip="{{'LANDINFOCUS.WIZARD.TITUTCORREGIR' | translate}}" matTooltipPosition="left" class="sinreporte mr-20">
      <mat-icon>highlight_off</mat-icon>
    </button>
    <button *ngIf="banderaEncuestaFocus.estatusVerificacion==5"  mat-raised-button class="sinreporte mr-20">
     {{'LANDINFOCUS.ENCUESTAS.ENC-CORRECI' | translate}}
      <mat-icon class="ml-20">done</mat-icon>
    </button>
</ng-container>

<ng-container>
  <button *ngIf="banderaEncuestaFocus.estatusVerificacion==2" mat-fab aria-label="boton completar paso" (click)="actualizaBanderaEvaluarEncuesta(3)"
  matTooltip="{{'LANDINFOCUS.WIZARD.TITUTAUTORIZAR' | translate}}" matTooltipPosition="left" class="undone mr-20">
  <mat-icon>done</mat-icon>
</button>
<button *ngIf="banderaEncuestaFocus.estatusVerificacion==3"  mat-raised-button class="done mr-20">
{{'LANDINFOCUS.ENCUESTAS.ENC-AUTO' | translate}}
  <mat-icon class="ml-20">done</mat-icon>
</button>
</ng-container>

</div>
